import React from 'react'
import PropTypes from 'prop-types'
import { HeadingText } from '@paypalcorp/pp-react'

import './shimmer-loader.less'

const sizeMapping = {
  xl: 'display',
  lg: 'lg',
  sm: 'sm',
}

// Created this component to load different shimmer sizes.
// TODO:: Actual shimmer from pp-react is not working so using Heading text for now.
const ShimmerLoader = (props) => {
  const { size } = props
  const getShimmer = () => {
    const shimmerSize = sizeMapping[size]
    return (
      <HeadingText
        data-testid="hc-shimmer-loader"
        className="hc_shimmer_loader"
        size={shimmerSize}
        isLoading
      >
        Loading...
      </HeadingText>
    )
  }

  return getShimmer()
}

ShimmerLoader.propTypes = {
  size: PropTypes.string,
}

ShimmerLoader.defaultProps = {
  size: 'xl',
}

export default ShimmerLoader
